import { getObjValue } from 'utils/functions';

export const isFetchingTemplates = props => getObjValue(props, 'getTemplates.loading', true);
export const isFetchingDomainRestrictedTemplates = props => getObjValue(props, 'getDomainRestrictedTemplates.loading', true);
export const isFetchingSubmittedTemplates = props => getObjValue(props, 'getSubmittedTemplates.loading', true);

export const getTemplatesSelector = props => getObjValue(props, 'getTemplates.getTemplates', []);
export const getDomainRestrictedTemplatesSelector = props => getObjValue(props, 'getDomainRestrictedTemplates.getDomainRestrictedTemplates', []);
export const getSubmittedTemplatesSelector = props => getObjValue(props, 'getSubmittedTemplates.getSubmittedTemplates', []);
